(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('encryptionStatusLogic', ["emailDao", "widgetPolling", "$filter", function (emailDao, widgetPolling, $filter) {
        function formatValue(value) {
            if (_(value).isArray()) {
                return _(value).map(function (val) {
                    return '#' + JSON.stringify({
                        'class': 'display-block',
                        display: 'text',
                        text: $filter('localTimeIfIsoString')('' + val)
                    });
                }).join('');
            } else {
                return $filter('localTimeIfIsoString')('' + value);
            }
        }
        return function ($scope, logic) {
            var id = logic.entityId || widgetPolling.scope().id;
            if (_($scope.model.wrapper.showLoading).isUndefined()) {
                $scope.model.wrapper.showLoading = true;
            }
            if (_($scope.model.wrapper.isLoading).isUndefined()) {
                $scope.model.wrapper.isLoading = true;
            }
            emailDao.getEncryptionStatus(id).then(function (response) {
                $scope.model.wrapper.isLoading = false;
                $scope.model.lines = [];
                if (response.data && response.data.message_status && response.data.message_status.length) {
                    _(response.data.message_status).chain().sortBy('Date').map(function (data) {
                        if (_(data).isObject()) {
                            // add Date, and Action columns first (ordering)
                            $scope.model.lines = $scope.model.lines.concat([
                                {
                                    text: '#' + JSON.stringify({
                                        display: 'text',
                                        'class': 'key',
                                        text: 'Date:'
                                    }) + '#' + JSON.stringify({
                                        display: 'linked-text',
                                        'class': 'value',
                                        text: formatValue(data.Date ? data.Date : '')
                                    }),
                                    'class': 'default-scan-details'
                                },
                                {
                                    text: '#' + JSON.stringify({
                                        display: 'text',
                                        'class': 'key',
                                        text: 'Action:'
                                    }) + '#' + JSON.stringify({
                                        display: 'linked-text',
                                        'class': 'value',
                                        text: formatValue(data.Action ? data.Action : '')
                                    }),
                                    'class': 'default-scan-details'
                                }
                            ]);
                            // add other values
                            _(data).each(function (val, key) {
                                if (key !== 'Date' && key !== 'Action') {
                                    $scope.model.lines.push({
                                        text: '#' + JSON.stringify({
                                            display: 'text',
                                            'class': 'key',
                                            text: key + ':'
                                        }) + '#' + JSON.stringify({
                                            display: 'linked-text',
                                            'class': 'value',
                                            text: formatValue(val)
                                        }),
                                        'class': 'default-scan-details'
                                    });
                                }
                            });
                            // add space for each block
                            $scope.model.lines.push({
                                text: '',
                                style: {
                                    clear: 'both',
                                    margin: '5px 0',
                                    padding: '8px 0'
                                }
                            });
                        } else {
                            $scope.model.lines.push({
                                text: data,
                                'class': 'echoworx-status-pair'
                            });
                        }
                        return data;
                    }).value();
                } else {
                    $scope.model.lines = [{ text: 'No Data' }];
                }
            });
        };
    }]);
}());